export default "__VITE_ASSET__5abcc10a__"